<template>
  <div v-editable="blok" class="marketing-product-slider">
    <AppProductSlider :items="sliderItems" />
  </div>
</template>

<script lang="ts" setup>
  const { blok } = defineProps<{
    blok: MarketingProductSliderBlokStoryblok;
  }>();

  // Filter items to only include MarketingProductSliderItemBlok items
  const sliderItems = computed(() => {
    return (blok.items || []).filter(
      (item): item is MarketingProductSliderItemBlokStoryblok => item.component === 'MarketingProductSliderItemBlok',
    );
  });
</script>
